import { TASKITEM_NAME } from '~shared/richtext/nodes/taskitem.node'

import type { JSONContent } from '@tiptap/react'

/**
 * CSS selector for a rendered task item `<li>`, matching the `data-type`
 * attribute TipTap's TaskItem renders.
 */
export const TASK_ITEM_SELECTOR = `li[data-type="${TASKITEM_NAME}"]`

/**
 * Returns a copy of the doc with the task item at `index` toggled.
 *
 * `index` is the depth-first (document order) position among all `taskItem`
 * nodes, which matches the order of `TASK_ITEM_SELECTOR` elements in the
 * rendered preview. Out-of-range indexes return an unchanged copy.
 *
 * @remarks
 *   The traversal does not assume a flat list. Nested task items are currently
 *   not allowed by the editor (see `TaskItemNode` in
 *   `~shared/richtext/nodes/taskitem.node`), but the depth-first order still
 *   matches the DOM if they are enabled later.
 */
export function toggleTaskItemChecked(
  doc: JSONContent,
  index: number,
): JSONContent {
  const updated = structuredClone(doc)
  let seen = 0

  const visit = (node: JSONContent) => {
    if (node.type === TASKITEM_NAME) {
      if (seen === index) {
        node.attrs = { ...node.attrs, checked: !node.attrs?.checked }
      }
      seen++
    }
    node.content?.forEach(visit)
  }

  visit(updated)
  return updated
}
